
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form3";
const form3State = namespace("Form3");

import Form3QualifyQuestions from "@/components/process/Form3/components/Form3QualifyQuestions.vue";
import { form3QualificationInfoType, form3DataInfoType } from '@/types/Information/Form3';

@Component({
    components:{
        Form3QualifyQuestions
    }
})
export default class ChecklistForm3 extends Vue {    
   
    @form3State.Action
    public UpdateForm3Info!: (newForm3Info: form3DataInfoType) => void

    disableContinue = true;
    businessAccount = true;
    inactiveButtonClass = "bg-secondary text-white"; 
    activeButtonClass = "bg-success text-white"; 
    qualificationInfo = {} as form3QualificationInfoType;
    
    // mounted(){       

    // }    

    public disableNavigateForm3(disable: boolean, qualificationInfo: form3QualificationInfoType) {        
        this.disableContinue = disable; 
        this.qualificationInfo = qualificationInfo;      
    }

    public navigateToForm3() {

        const form3SubmissionData = {} as form3DataInfoType;
        form3SubmissionData.selfRepresenting = this.qualificationInfo.selfRepresenting;
        form3SubmissionData.filedNoA = this.qualificationInfo.filedNoA;
        form3SubmissionData.insideTimeLimit = this.qualificationInfo.insideTimeLimit;
        form3SubmissionData.vary = this.qualificationInfo.vary;
        form3SubmissionData.appealingFeesWaived = this.qualificationInfo.appealingFeesWaived;        
        form3SubmissionData.appealingSupremeCourtOrder = this.qualificationInfo.appealingSupremeCourtOrder;
        form3SubmissionData.appealingScFlaDivorce = this.qualificationInfo.appealingScFlaDivorce;  
        this.UpdateForm3Info(form3SubmissionData);        
        this.$router.push({name: "start-form3"});
               
    }

}
